import React, { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, Tabs, Spin } from '@arco-design/web-react';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '@/modules/core/error-handling/ErrorBoundary';

const PaymentsList = React.lazy(() => import('./payments/PaymentsList'));
const SubscriptionsList = React.lazy(() => import('./subscriptions/SubscriptionsList'));
const DisputesList = React.lazy(() => import('./disputes/DisputesList'));
const NewChargeForm = React.lazy(() => import('./checkout/NewChargeForm'));

const TabPane = Tabs.TabPane;

const TabFallback = () => (
  <div style={{ padding: 40, textAlign: 'center' }}>
    <Spin size={30} />
  </div>
);

const CobranzaPage = () => {
  const { t } = useTranslation('finance');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'pagos';

  const handleTabChange = (tab) => {
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <div style={{ padding: 0 }}>
      <Tabs
        activeTab={activeTab}
        onChange={handleTabChange}
        lazyload
        destroyOnHide={false}
        style={{ marginTop: 8 }}
      >
        <TabPane key="pagos" title={t('tabs.payments')}>
          <ErrorBoundary>
            <Suspense fallback={<TabFallback />}>
              <Card style={{ marginTop: 8 }}>
                <PaymentsList />
              </Card>
            </Suspense>
          </ErrorBoundary>
        </TabPane>

        <TabPane key="suscripciones" title={t('tabs.subscriptions')}>
          <ErrorBoundary>
            <Suspense fallback={<TabFallback />}>
              <Card style={{ marginTop: 8 }}>
                <SubscriptionsList />
              </Card>
            </Suspense>
          </ErrorBoundary>
        </TabPane>

        <TabPane key="disputas" title={t('tabs.disputes')}>
          <ErrorBoundary>
            <Suspense fallback={<TabFallback />}>
              <Card style={{ marginTop: 8 }}>
                <DisputesList />
              </Card>
            </Suspense>
          </ErrorBoundary>
        </TabPane>

        <TabPane key="nuevo-cobro" title={t('tabs.newCharge')}>
          <ErrorBoundary>
            <Suspense fallback={<TabFallback />}>
              <NewChargeForm />
            </Suspense>
          </ErrorBoundary>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default CobranzaPage;
